import { useEffect, useState } from 'react'
import { createStrictContext } from 'utils/createContext'
import { usePayItemSelectContext } from 'components/CIMSSelect/common/PayItemSelect/PayItemSelectContext'
import { simpleErrorNotification } from 'hooks/notificationHandler'
import { SummaryContext } from './types'
import { Connection, Internal } from '../../../PayItemsModuleContext/types'
import { useProjectContext } from 'context/ProjectContext'

const { Provider, useContextFn } =
  createStrictContext<SummaryContext>('SummaryContext')

export const useSummaryContext = useContextFn

const SummaryProvider: React.FC = ({ children }) => {
  const { projectId } = useProjectContext()
  const [globalId, setGlobalId] = useState<string | undefined>()
  const [selected, setSelected] = useState<Internal | Connection | undefined>()
  useEffect(() => {
    setGlobalId(undefined)
    setSelected(undefined)
  }, [projectId])

  const { payItems } = usePayItemSelectContext()
  const [copied, setCopied] = useState<string | undefined>()
  useEffect(() => {
    if (!globalId || !payItems) return
    const found = payItems.find((payItem) => payItem.globalId === globalId)
    if (!found)
      return simpleErrorNotification(
        `Could not find a Pay Item by ${globalId}. Try selecting a different Pay Item`
      )
    setCopied(found.label)
  }, [globalId, payItems])
  return (
    <Provider
      value={{
        copied,
        globalId,
        setGlobalId,
        selected,
        setSelected,
      }}
    >
      {children}
    </Provider>
  )
}

export default SummaryProvider
